import type { ProductSetFromMutation } from 'src/types/product';

const defaultState = null;

const RESET = 'session/createProductSetRequest/RESET' as const;
const UPDATE = 'session/createProductSetRequest/UPDATE' as const;

export type CreateProductSetRequest = Promise<{
  productSet?: ProductSetFromMutation | null;
  error?: unknown;
}>;

type ResetAction = {
  type: 'session/createProductSetRequest/RESET';
};

type UpdateAction = {
  type: 'session/createProductSetRequest/UPDATE';
  value: CreateProductSetRequest;
};

export const actionResetCreateProductSetRequest = () => ({
  type: RESET,
});

export const actionUpdateCreateProductSetRequest = (
  value: CreateProductSetRequest,
) => ({
  type: UPDATE,
  value,
});

export default (
  state: CreateProductSetRequest | null = defaultState,
  action: ResetAction | UpdateAction,
): CreateProductSetRequest | null => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
